"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _borders = require("../style/borders");
var _fonts = require("../style/fonts");
var _Warning = _interopRequireDefault(require("../Icon/Icons/Warning"));
var _Cross = _interopRequireDefault(require("../Icon/Icons/Cross"));
var _Buffer = _interopRequireDefault(require("../Icon/Icons/Buffer"));
var _colors = require("../style/colors");
var _AnimationWrapper = require("../AnimationWrapper");
var _animations = require("../style/animations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const colorMap = {
  alert: {
    border: _colors.redDark,
    background: _colors.redLightest,
    color: _colors.redDarker
  },
  warning: {
    border: _colors.yellowDark,
    background: _colors.yellowLightest,
    color: _colors.yellowDarker
  },
  note: {
    border: _colors.grayDark,
    background: _colors.grayLighter,
    color: _colors.grayDarker
  },
  tip: {
    border: _colors.purpleDark,
    background: _colors.purpleLightest,
    color: _colors.purpleDarker
  }
};
const NoticeWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Notice__NoticeWrapper",
  componentId: "bufferapp-ui__sc-x9sirn-0"
})(["border:", ";color:", ";background:", ";border-radius:", ";font-size:", ";padding:8px ", " 8px 8px;display:flex;justify-content:flex-start;align-items:center;position:relative;width:100%;"], props => `1px solid ${colorMap[props.type].border}`, props => colorMap[props.type].color, props => colorMap[props.type].background, _borders.borderRadius, _fonts.fontSize, _ref => {
  let {
    dismiss
  } = _ref;
  return dismiss ? '28px' : '8px';
});
const WarningIcon = /*#__PURE__*/(0, _styledComponents.default)(_Warning.default).withConfig({
  displayName: "Notice__WarningIcon",
  componentId: "bufferapp-ui__sc-x9sirn-1"
})(["display:block;margin-right:12px;flex:1 0 auto;max-width:16px;"]);
const BufferIcon = /*#__PURE__*/(0, _styledComponents.default)(_Buffer.default).withConfig({
  displayName: "Notice__BufferIcon",
  componentId: "bufferapp-ui__sc-x9sirn-2"
})(["display:block;margin-right:12px;flex:1 0 auto;max-width:16px;"]);
const CloseButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "Notice__CloseButton",
  componentId: "bufferapp-ui__sc-x9sirn-3"
})(["color:", ";border:0;background:0;padding:0;margin:0;opacity:0.8;height:16px;position:absolute;right:16px;&:hover{color:", ";opacity:1;cursor:pointer;}"], props => colorMap[props.type].color, props => colorMap[props.type].color);
function Notice(_ref2) {
  let {
    children,
    dismiss,
    type,
    className,
    disableAnimation
  } = _ref2;
  const {
    AnimationWrapper,
    dismiss: dismissAnimationWrapper,
    animationProps
  } = (0, _AnimationWrapper.useAnimation)({
    justify: 'flex-end',
    stageInAnimation: disableAnimation ? undefined : _animations.stageInRight,
    stageOutAnimation: disableAnimation ? undefined : _animations.fadeOut,
    onDismiss: dismiss
  });
  const noticeContent = /*#__PURE__*/_react.default.createElement(NoticeWrapper, {
    type: type,
    dismiss: dismiss,
    className: className
  }, type === 'warning' && /*#__PURE__*/_react.default.createElement(WarningIcon, null), type === 'alert' && /*#__PURE__*/_react.default.createElement(WarningIcon, null), type === 'tip' && /*#__PURE__*/_react.default.createElement(BufferIcon, null), children, dismiss && ( /*#__PURE__*/_react.default.createElement(CloseButton, {
    type: type,
    onClick: () => dismissAnimationWrapper()
  }, /*#__PURE__*/_react.default.createElement(_Cross.default, null))));
  return /*#__PURE__*/_react.default.createElement(AnimationWrapper, Object.assign({}, animationProps), noticeContent);
}
Notice.propTypes = {
  children: _propTypes.default.node.isRequired,
  dismiss: _propTypes.default.func,
  disableAnimation: _propTypes.default.bool,
  type: _propTypes.default.string.isRequired
};
Notice.defaultProps = {
  dismiss: null,
  disableAnimation: false
};
var _default = exports.default = Notice;